module.exports = __webpack_public_path__ + "kudos_17.svg?63d3e5a357f51be06cdbc0d2a322b558";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_17.svg
// module id = 114
// module chunks = 0